import React, { createContext, useState } from "react";

export const StepperContext = createContext();

export const StepperProvider = ({ children }) => {
  const [step, setStep] = useState(1);

  return (
    <StepperContext.Provider value={{ step, setStep }}>
      {children}
    </StepperContext.Provider>
  );
};
